// extracted by mini-css-extract-plugin
export var content = "page-layout-module--content--8971d";
export var main = "page-layout-module--main--8c441";
export var page = "page-layout-module--page--06acb";